import $ from 'jquery';

(function ($) {
  $(document).ready(function () {
    if ($('#add_report_job').length < 1) {
      return;
    }
    $('.js_addReceiver').click(function (e) {
      e.preventDefault();
      let currentCount = Date.now(); //$(this).closest('.tyres-fieldsets').find('fieldset > fieldset').length;
      let template = $(this).closest('.tyres-fieldsets').find('fieldset > span').data('template');
      template = template.replace(/__index__/g, currentCount);
      $(this).closest('.tyres-fieldsets').children('fieldset').append(template);
      numerizeFieldsets();
      return false;
    });
    numerizeFieldsets();
  });

  const numerizeFieldsets = () => {
    let cnt = 1;
    $('.tyres-fieldsets > fieldset > fieldset').each(function () {
      const id = $(this).find('input').first().attr('name').match(/\[(\d+)\]/)[1];
      $(this).attr('data-id', id);
      if ($(this).find('legend').length === 0) {
        $(this).prepend('<legend>');
      }
      const legend = $(this).find('legend');
      legend.html('');
      legend.text('Odbiorca ' + cnt);
      cnt++;
      if (id === '0') {
        return;
      }
      legend.append(
        $('<a class="" style="margin-left: 1em">')
          .text('(Usuń)')
          .click(function () {
            $('fieldset[data-id=' + id + ']').remove();
          })
      );

    });
  }
})($);
